//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from "vuex";
import { uid } from "quasar";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";
import AQDropdown from "@/components/Generics/AQDropdown/AQDropdown.vue";
import setConditions from "@/components/Diagrams/config/set-conditions.vue";

export default {
    name: "RuleEditorMapRequest",
    components: {
        AQModal, AQInput, setConditions, AQDialog, AQDropdown, AQCard
    },
    props: { ruleId: String, rulesParentArray: Array, selectedFields: Array },
    data() {
        return {
            editRulesModal: true,
            invalidName: false,
            extendParent: false,
            editMode: false,
            conditionExistance: false,
            copyRuleInfo: {},
            primary: null,
            errorMsg: "",
            message: "",
            codeFound: false,
            currentRule: {
                name: "",
                description: "",
                conditions: {},
                errorCode: ""
            },
            copyBasicRule: {
                name: "",
                description: "",
                conditions: {
                    statement: "",
                    conditions: []
                },
                errorCode: "400"

            },
            rulesOpts: [
                { label: this.$t("diagrams.components.externalStart.errorCode418"), value: "418" },
                { label: this.$t("diagrams.components.externalStart.errorCode400"), value: "400" },
                { label: this.$t("diagrams.components.externalStart.errorCode500"), value: "500" }
            ],
            headerActionsModel: [{
                id: "deleteRule",
                name: this.$t("diagrams.components.setLevels.delete")
            }],
            headerActions: [],
            showDialog: false
        };
    },
    computed: {
        ...mapGetters("diagrams", ["selectedPluginConfigData"]),
        errorMessage: {
            get() {
                if (this.currentRule.errorMessage && !this.codeFound) {
                    this.message = this.currentRule.errorMessage;
                } else if (!this.codeFound && this.currentRule.errorCode) {
                    if (this.currentRule.errorCode === "418") {
                        this.message = this.$t("diagrams.components.externalStart.error418");
                    } else if (this.currentRule.errorCode === "400") {
                        this.message = this.$t("diagrams.components.externalStart.error400");
                    } else if (this.currentRule.errorCode === "500") {
                        this.message = this.$t("diagrams.components.externalStart.error500");
                    }
                    this.codeFound = false;
                }
                return this.message;
            },
            set(v) {
                this.message = v;
                this.codeFound = true;
            }
        },
        getRuleId() {
            return this.ruleId;
        }
    },
    watch: {
        editMode: {
            handler() {
                if (this.editMode) {
                    this.primary = { label: this.$t("admin.usersAndRoles.permissionsModal.updateBtn"), disabled: !this.conditionExistance };
                    this.headerActions = [{ label: this.$t("diagrams.components.setLevels.delete") }];
                } else {
                    this.primary = { label: this.$t("diagrams.components.externalStart.addBtn"), disabled: !this.conditionExistance };
                }
            },
            immediate: true
        },
        currentRule: {
            deep: true,
            handler(value) {
                if (value.conditions.conditions && value.conditions.conditions.length) {
                    this.conditionExistance = true;
                    this.primary.disabled = false;
                } else {
                    this.conditionExistance = false;
                    this.primary.disabled = true;
                }
            }
        }
    },
    created() {
        let found = false;
        if (this.rulesParentArray.length) {
            for (let i = 0; i < this.rulesParentArray.length; i++) {
                if (this.rulesParentArray[i].uuid === this.getRuleId) {
                    this.copyRuleInfo = { ...this.rulesParentArray[i] };
                    this.currentRule = { ...this.rulesParentArray[i] };
                    this.editMode = true;
                    found = true;
                }
            }
            if (!found) {
                this.copyRuleInfo = this.copyBasicRule;
            }
        } else {
            this.copyRuleInfo = this.copyBasicRule;
        }
        if (!this.currentRule.errorCode) {
            this.currentRule.errorCode = this.rulesOpts[1].value;
        }
    },
    methods: {
        defineRequestAction(action) {
            if (action === "primary") {
                if (!this.currentRule.name) {
                    this.invalidName = true;
                    this.$toast.showNotify({
                        type: "warning",
                        message: this.$t("diagrams.components.setRules.ruleNameRequired")
                    });
                    return false;
                }
                this.invalidName = false;
                this.uuid = this.currentRule.uuid || uid();
                this.$emit("rulesEditorList", {
                    uuid: this.uuid,
                    name: this.currentRule.name,
                    index: 0,
                    description: this.currentRule.description,
                    conditions: this.currentRule.conditions,
                    errorCode: this.currentRule.errorCode,
                    errorMessage: this.message
                });
                this.editRulesModal = false;
                this.$emit("input", false);
                this.$emit("closeRuleEditorModal");
            } else {
                if (JSON.stringify(this.copyRuleInfo) !== JSON.stringify(this.currentRule)) {
                    this.showDialog = true;
                } else {
                    this.editRulesModal = false;
                    this.$emit("input", false);
                    this.$emit("closeRuleEditorModal");
                }
                if (action === this.$t("diagrams.components.setLevels.delete")) {
                    this.rulesParentArray.splice(this.currentRule.index, 1);
                    for (let i = this.currentRule.index; i < this.rulesParentArray.length; i++) {
                        this.rulesParentArray[i].index--;
                    }
                }
            }
        },
        ok() {
            this.editRulesModal = false;
            this.showDialog = false;
            this.$emit("input", false);
            this.$emit("closeRuleEditorModal");
        },
        cancel() {
            this.showDialog = false;
        },
        afterHide() {
            this.$emit("input", false);
        },
        selectErrorCode(selectedVal) {
            let found = false;
            this.currentRule.errorCode = selectedVal || "";
            if (selectedVal) {
                if (selectedVal === this.copyRuleInfo.errorCode) {
                    if (this.copyRuleInfo.errorMessage) {
                        this.message = this.copyRuleInfo.errorMessage;
                        found = true;
                    } else {
                        found = false;
                    }
                } else if (!found) {
                    if (selectedVal === "418") {
                        this.message = this.$t("diagrams.components.externalStart.error418");
                    } else if (selectedVal === "400") {
                        this.message = this.$t("diagrams.components.externalStart.error400");
                    } else if (selectedVal === "500") {
                        this.message = this.$t("diagrams.components.externalStart.error500");
                    }
                }
            }
            this.codeFound = true;
        }
    }
};
